/* eslint-disable */
const getters = {
  getAvailabilities(state) {
    return state.data;
  },
};

export default getters;
